import React from 'react';

import { Inline } from '~shared/components/Inline';
import { ReactNodeNoStrings } from '~shared/types';

interface Props {
  children: ReactNodeNoStrings;
  isChecked?: boolean;
  showShortcuts?: boolean;
  shortcuts?: ReactNodeNoStrings;
}

export function QuizListItemActions({
  children,
  isChecked,
  showShortcuts,
  shortcuts,
}: Props) {
  return (
    <div className="absolute top-px right-0 bottom-0 flex">
      <div
        className={`w-12 h-full bg-gradient-to-l ${
          isChecked ? 'from-cyan-50' : 'from-white'
        }`}
      />
      <div
        className={`flex items-center pb-px ${
          isChecked ? 'bg-cyan-50' : 'bg-white'
        }`}
      >
        <Inline>
          {showShortcuts && !!shortcuts ? shortcuts : null}
          {children}
        </Inline>
      </div>
    </div>
  );
}
